module.exports = __webpack_public_path__ + "img/bg02_zhCn.626011ec.png";